import { Box } from '@fhs-legacy/universal-components';

export const Wrapper = Box.withConfig({
  justifyContent: 'center',
});
